import { createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-a6539666")

_pushScopeId("data-v-a6539666")
const _hoisted_1 = { class: "order-result" }
const _hoisted_2 = /*#__PURE__*/_createVNode("h2", { class: "-bold" }, "결제 상세정보", -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_RequestView = _resolveComponent("RequestView")
  const _component_OrderResultView = _resolveComponent("OrderResultView")
  const _component_CancelConfirm = _resolveComponent("CancelConfirm")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    (!_ctx.state.isLoading && !!_ctx.state.RequestKey)
      ? (_openBlock(), _createBlock(_component_RequestView, {
          key: 0,
          onCancelRequest: _ctx.CancelRequest,
          id: _ctx.state.RequestKey,
          orderNumber: _ctx.state.orderNumber
        }, {
          title: _withId(() => [
            _hoisted_2
          ]),
          _: 1
        }, 8, ["onCancelRequest", "id", "orderNumber"]))
      : _createCommentVNode("", true),
    _createVNode(_component_OrderResultView, {
      id: _ctx.state.paymentKey,
      onUpdateCardInfo: _cache[1] || (_cache[1] = 
        (orderNumber) => {
          _ctx.updateCardInfo(orderNumber);
        }
      )
    }, null, 8, ["id"]),
    _createVNode(_component_CancelConfirm, {
      ref: "cancel$",
      accept: _ctx.CancelAccept
    }, null, 8, ["accept"])
  ]))
})